import React, { useEffect, useState } from 'react';
import { RichText } from 'prismic-reactjs';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { TextVariant, Typography } from '@components/shared/design/Typography';
import { BREAKPOINT } from '@constants';

export interface Props {
  article: any;
}

// TODO Delete this whole file once https://app.asana.com/0/home/1207586784179529/1208456938900162 is unblocked

export default function ArticleWrittenBox({ article }: Props) {
  const [writtenBy, setWrittenBy] = useState<any>();

  useEffect(() => {
    const getAuthors = () => {
      if (article.data.author) {
        const { author } = article.data;
        if (author.slug) {
          setWrittenBy(author.slug.replace(/-/g, ' '));
        }
      }
    };

    getAuthors();
  }, [article.author]);

  return (
    <WrittenByBox $writtenBy={writtenBy}>
      {writtenBy && (
        <>
          <Typography $variant={TextVariant.BodyRegularMD}>
            Written by <AuthorName $variant={TextVariant.BodyRegularMD}>{writtenBy}</AuthorName>
          </Typography>
          <br />
        </>
      )}
      <IllustratorStyled $variant={TextVariant.BodyRegularMD}>{RichText.render(article.data.hero_credits.richText)}</IllustratorStyled>
    </WrittenByBox>
  );
}

interface WrittenByBoxProps {
  $writtenBy: any;
}

const WrittenByBox = styled.div<WrittenByBoxProps>`
  width: 100%;
  height: auto;
  position: relative;
  text-align: left;
  transform: none;
  position: relative;

  @media only screen and (max-width: ${BREAKPOINT.laptop}px) {
    max-width: 100%;
    width: 100%;
    margin-left: 0;
    position: relative;
  }
`;

const AuthorName = styled(Typography)`
  text-transform: capitalize;
  display: inline;
`;

const IllustratorStyled = styled(Typography)`
  & p {
    font-size: 14px;
    line-height: 140%;
    color: ${Colors.navyBlue};
  }
  & p:not(:last-child) {
    margin-bottom: 14px;
  }
  & a {
    color: ${Colors.navyBlue};
    text-decoration: underline;
  }
`;
